import React from 'react';
import type { UserStats } from '../types/userList.types';
import { Users, UserCheck, UserMinus, UserX, Clock } from 'lucide-react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

interface UserStatsCardsProps {
  stats?: UserStats;
}

export function UserStatsCards({ stats }: UserStatsCardsProps) {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng nhân sự',
      value: stats?.total || 0,
      suffix: 'người',
      icon: Users,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [50, 50, 50, 50, 50, 50]
    },
    {
      title: 'Đang làm việc',
      value: stats?.active || 0,
      suffix: stats?.total ? `${Math.round((stats.active/stats.total)*100)}%` : '0%',
      icon: UserCheck,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Khả dụng',
      chartColor: 'bg-emerald-500',
      chartData: [80, 85, 90, 85, 95, 90, 100]
    },
    {
      title: 'Nghỉ phép',
      value: stats?.on_leave || 0,
      suffix: stats?.total ? `${Math.round((stats.on_leave/stats.total)*100)}%` : '0%',
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'neutral',
      trendValue: 'Trong tuần',
      chartColor: 'bg-amber-500',
      chartData: [10, 15, 10, 20, 15, 10, 5]
    },
    {
      title: 'Tạm nghỉ',
      value: stats?.suspended || 0,
      suffix: stats?.total ? `${Math.round((stats.suspended/stats.total)*100)}%` : '0%',
      icon: UserMinus,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'down',
      trendValue: 'Bất thường',
      chartColor: 'bg-indigo-500',
      chartData: [5, 5, 10, 5, 0, 5, 5]
    },
    {
      title: 'Đã nghỉ việc',
      value: stats?.resigned || 0,
      suffix: stats?.total ? `${Math.round((stats.resigned/stats.total)*100)}%` : '0%',
      icon: UserX,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'neutral',
      trendValue: 'Cần lưu ý',
      chartColor: 'bg-rose-500',
      chartData: [0, 0, 0, 5, 0, 0, 0]
    },
  ];

  return <KpiGrid kpis={kpis} />;
}
